<template>
  <div class="about">
    <h1>UMBGrup fc/faz</h1>
  </div>
</template>

<script>
//import {mapState} from 'vuex'

export default {
  async beforeCreate(){
    //await this.$store.dispatch('rrefAuthenticated')
    this.$store.dispatch('checkAuthenticated')
    //alert("about-"+this.$store.state.authenticated)
    this.$router.push("/acasa")
  }
}
</script>